import { Block } from 'baseui/block';
// types
import { ISP_Pipe } from './types'
import { schemaPump } from '../../Devices/DriveOneSpeed/types'
import { schemaPump as schemaPumpVar } from '../../Devices/DriveVarSpeed/types'
import { schema as schemaValveVar } from '../../Devices/ValveVar/types'
import { schema as schemaValveTwoPoint } from '../../Devices/ValveTwoPoint/types'
// components
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { SmallPanel as AlarmPanel } from '../../Devices/SensorDigitalAlarm/SmallPanel'
import { default as TrendPanel } from './TrendPanel';
import { ValueDisplayIcon } from '../../components/ValueDisplay'
import { LoadingView } from "../../../components";
// api
import { themedUseStyletron } from '../../../theme/customTheme'
import { IconPipe } from './IconPipe';
import { useGetObjectsChildren } from '../../../hooks/useGetObjectsChildren';
import { useMemo } from 'react';
import { SmallPanel as PumpOneSpeedPanel } from '../../Devices/DriveOneSpeed';
import { SmallPanel as PumpVarSpeedPanel } from '../../Devices/DriveVarSpeed';
import { SmallPanel as ValveVarPanel } from '../../Devices/ValveVar';
import { SmallPanel as ValveTwoPointPanel } from '../../Devices/ValveTwoPoint';
import { FormattedMessage } from 'react-intl';
import { Badge } from 'baseui/badge';

export function OverviewPanel(props: ISP_Pipe) {
    const [, theme] = themedUseStyletron();
    const { children: childElement, isLoading, isSuccess, error } = useGetObjectsChildren(props.resourceGroupId, props.id)

    const temperature = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.TemperatureSensor"), [childElement]);
    const ftemperature = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.FlowTemperatureSensor"), [childElement]);
    const otemperature = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.OutletTemperatureSensor"), [childElement]);
    const pressure = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.PressureSensor"), [childElement]);
    const sensor = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.SensorAnalog"), [childElement]);
    const alarm = useMemo(() => childElement?.find((v: any) => v.schema === "AutomationApps.Devices.Sensors.SensorDigitalAlarm"), [childElement]);

    const circulationPump = useMemo(() => childElement?.find((v: any) => v.schema === schemaPump), [childElement]);
    const circulationPumpVar = useMemo(() => childElement?.find((v: any) => v.schema === schemaPumpVar), [childElement]);
    const circulationValveVar = useMemo(() => childElement?.find((v: any) => v.schema === schemaValveVar), [childElement]);
    const circulationValveTwoPoint = useMemo(() => childElement?.find((v: any) => v.schema === schemaValveTwoPoint), [childElement]);

    const hasAggregates = circulationPump || circulationPumpVar || circulationValveVar || circulationValveTwoPoint;
    return (
        <OverviewPanelWrapper includeAlarmsFromChildren {...props} icon={<IconPipe color={theme.colors.backgroundPrimary}></IconPipe>}>
            <LoadingView isLoading={isLoading} error={error} isSucess={isSuccess}>
                {hasAggregates && <>
                    {props.isOn && <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="Devices.ON" defaultMessage="On" />} />}
                    {!props.isOn && <Badge hierarchy='secondary' color='primary' content={<FormattedMessage id="Devices.OFF" defaultMessage="Off" />} />}
                </>}

                <>
                    {circulationPump && <PumpOneSpeedPanel {...circulationPump}></PumpOneSpeedPanel>}
                    {circulationPumpVar && <PumpVarSpeedPanel {...circulationPumpVar}></PumpVarSpeedPanel>}
                    {circulationValveVar && <ValveVarPanel {...circulationValveVar}></ValveVarPanel>}
                    {circulationValveTwoPoint && <ValveTwoPointPanel {...circulationValveTwoPoint}></ValveTwoPointPanel>}
                    <Block display='flex' flexDirection='row' alignItems='center' justifyContent='center' gridGap='20px'>
                        {temperature &&
                            <ValueDisplayIcon {...temperature}></ValueDisplayIcon>
                        }
                        {ftemperature &&
                            <ValueDisplayIcon {...ftemperature}></ValueDisplayIcon>
                        }
                        {otemperature &&
                            <ValueDisplayIcon {...otemperature}></ValueDisplayIcon>
                        }
                        {sensor &&
                            <ValueDisplayIcon {...sensor}></ValueDisplayIcon>
                        }
                        {pressure &&
                            <ValueDisplayIcon {...pressure}></ValueDisplayIcon>
                        }
                        {alarm?.isErr &&
                            <AlarmPanel {...alarm}></AlarmPanel>
                        }

                    </Block>
                    {temperature &&
                        <TrendPanel temperature={temperature} pressure={pressure} />
                    }
                    {ftemperature &&
                        <TrendPanel temperature={ftemperature} pressure={pressure} />
                    }
                    {otemperature &&
                        <TrendPanel temperature={otemperature} pressure={pressure} />
                    }
                    {sensor &&
                        <TrendPanel temperature={sensor} pressure={pressure} />
                    }
                </>
            </LoadingView>
        </OverviewPanelWrapper>
    );
}